// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBAptWaEVMP0JgE8iU9G4b7rzDftBANWfs",
    authDomain: "supernova-241508.firebaseapp.com",
    databaseURL: "https://supernova-241508.firebaseio.com",
    projectId: "supernova-241508",
    storageBucket: "supernova-241508.appspot.com",
    messagingSenderId: "486916345026",
    appId: "1:486916345026:web:33a5984abf08eb14"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
